export default "__VITE_ASSET__336d24bc__"